"use strict";

var _slicedToArray = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _taggedTemplateLiteral = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShapeMenu = exports.StructuredShapeMenu = exports.StructuredProductMenu = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = __importDefault(require("react"));

var react_2 = require("@emotion/react");

var styled_1 = __importDefault(require("@emotion/styled"));

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var frontend_application_1 = require("@ryerson/frontend.application");

var frontend_navigation_1 = require("@ryerson/frontend.navigation");

var frontend_layout_2 = require("@ryerson/frontend.layout");

var frontend_assets_1 = require("@ryerson/frontend.assets");

var frontend_navigation_2 = require("@ryerson/frontend.navigation");

var util_1 = require("../common/util");

var Constants_1 = require("../common/Constants");

var productMenuContent_1 = require("./productMenuContent");

var Divider = styled_1.default.hr(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tmargin-top: 10px;\n\tmargin-bottom: 10px;\n\topacity: 0.1;\n\t", ";\n"])), function (props) {
  var white = props.white;
  return (0, react_2.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\t\tborder-top: 1px solid ", ";\n\t\t"])), white);
});
var Box = styled_1.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\tpadding-right: 40px;\n"])));

var StructuredProductMenu = function StructuredProductMenu(_ref) {
  var product = _ref.product,
      isExpanded = _ref.isExpanded,
      isSticky = _ref.isSticky,
      storeDirectory = _ref.storeDirectory;

  var _a;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var _react_1$default$useS = react_1.default.useState(),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      highlightedShape = _react_1$default$useS2[0],
      setHighlightedShape = _react_1$default$useS2[1];

  var _theme$colors$primary = theme.colors.primary,
      darkGray = _theme$colors$primary.darkGray,
      lightGray = _theme$colors$primary.lightGray,
      secondaryBrand = _theme$colors$primary.secondaryBrand,
      white = _theme$colors$primary.white;

  var _ref3 = (0, frontend_application_1.useApplication)(),
      language = _ref3.localization.language;

  var content = productMenuContent_1.ProductMenuContent[language] || productMenuContent_1.ProductMenuContent.en;
  var buttonLinkPath = Constants_1.productPaths.find(function (productItem) {
    return productItem.contentful_id === product.contentful_id;
  });
  var top = isSticky ? "160px" : "200px";
  var background = "linear-gradient(90deg, ".concat(secondaryBrand, " 63%, ").concat(darkGray, " 37%)");
  var MenuContainer = styled_1.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\tright: 0;\n\t\ttop: ", ";\n\t\tmargin-left: auto;\n\t\tmargin-right: auto;\n\t\tbox-sizing: border-box;\n\t\tbackground: ", ";\n\t\toverflow: hidden;\n\t"])), top, background);
  var staticAssetsUrl = "/static-assets/images/renderings/";

  var addImageDefaultSrc = function addImageDefaultSrc(event) {
    event.target.src = "".concat(staticAssetsUrl, "NoImageAvailable.png");
  };

  var MegamenuImage = (0, styled_1.default)(frontend_layout_1.FlexItem)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\t\tposition: absolute;\n\t\tright: -3%;\n\t\t@media only screen and (max-width: ", ") {\n\t\t\tmax-width: 17%;\n\t\t}\n\t\t@media only screen and (min-width: ", ") {\n\t\t\tmax-width: 22%;\n\t\t}\n\t\talign-self: flex-end;\n\t"])), theme.breakpoints.xxl, theme.breakpoints.xxl);

  var getProductSummary = function getProductSummary() {
    var _a, _b, _c, _d, _e;

    return (0, jsx_runtime_1.jsxs)(react_1.default.Fragment, {
      children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
        css: {
          marginBottom: "30px"
        },
        "data-tesid": "product-menu-selected-product-summary",
        children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
          variant: "h2",
          type: "tertiary",
          css: (0, react_2.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\t\t\t\t\t\tmargin: 0;\n\t\t\t\t\t\tpadding-top: 10px;\n\t\t\t\t\t\tline-height: 65px;\n\t\t\t\t\t"]))),
          children: product === null || product === void 0 ? void 0 : product.label
        })
      }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
        children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
          css: {
            width: "65%"
          },
          children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            variant: "div",
            type: "tertiary",
            size: "sm",
            children: (_b = (_a = product === null || product === void 0 ? void 0 : product.productCategory) === null || _a === void 0 ? void 0 : _a.blurb) === null || _b === void 0 ? void 0 : _b.blurb
          })
        }), (0, jsx_runtime_1.jsx)(MegamenuImage, {
          children: (0, jsx_runtime_1.jsx)("img", {
            onError: function onError(event) {
              return addImageDefaultSrc(event);
            },
            src: (_e = (_d = (_c = product === null || product === void 0 ? void 0 : product.productCategory) === null || _c === void 0 ? void 0 : _c.seoImage) === null || _d === void 0 ? void 0 : _d.file) === null || _e === void 0 ? void 0 : _e.url,
            width: "100%"
          })
        })]
      })]
    });
  };

  var shapeDetailStyle = (0, react_2.css)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n\t\tdisplay: block;\n\t\tposition: relative;\n\t\tmargin-top: 20px;\n\t\tmargin-left: -27px;\n\t\tmax-width: 138px;\n\t"])));

  var getShapeDetails = function getShapeDetails(linkDetails) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;

    var characteristics = [];
    (_b = (_a = linkDetails === null || linkDetails === void 0 ? void 0 : linkDetails.productSubCategory) === null || _a === void 0 ? void 0 : _a.characteristicsProperties) === null || _b === void 0 ? void 0 : _b.forEach(function (characteristic) {
      characteristics.push(characteristic.title);
    });
    if (characteristics.length > 1) characteristics[characteristics.length - 1] = "as well as " + characteristics[characteristics.length - 1];
    var grades = [];
    (_d = (_c = linkDetails === null || linkDetails === void 0 ? void 0 : linkDetails.productSubCategory) === null || _c === void 0 ? void 0 : _c.gradeTableItem) === null || _d === void 0 ? void 0 : _d.forEach(function (gradeItem) {
      grades.push(gradeItem.grade);
    });
    if (grades.length > 1) grades[grades.length - 1] = "and " + grades[grades.length - 1];
    return (0, jsx_runtime_1.jsxs)(frontend_layout_2.Grid, {
      gutter: 0,
      dataTestId: "product-shape-details",
      children: [(0, jsx_runtime_1.jsxs)(frontend_layout_2.Row, {
        children: [(0, jsx_runtime_1.jsx)(frontend_layout_2.Column, {
          lg: 4,
          children: linkDetails && (0, jsx_runtime_1.jsx)("img", {
            onError: function onError(event) {
              return addImageDefaultSrc(event);
            },
            src: ((_g = (_f = (_e = linkDetails === null || linkDetails === void 0 ? void 0 : linkDetails.productSubCategory) === null || _e === void 0 ? void 0 : _e.seoImage) === null || _f === void 0 ? void 0 : _f.file) === null || _g === void 0 ? void 0 : _g.url) + "?fit=pad&w=138&h=138",
            css: shapeDetailStyle
          })
        }), (0, jsx_runtime_1.jsx)(frontend_layout_2.Column, {
          lg: 8,
          children: (0, jsx_runtime_1.jsxs)(frontend_layout_2.Grid, {
            gutter: 0,
            children: [(0, jsx_runtime_1.jsx)(frontend_layout_2.Row, {
              children: (0, jsx_runtime_1.jsx)(frontend_layout_2.Column, {
                lg: 12,
                children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                  variant: "h4",
                  color: lightGray,
                  css: (0, react_2.css)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\tmargin-bottom: 24px;\n\t\t\t\t\t\t\t\t\t\t"]))),
                  children: (_j = (_h = linkDetails === null || linkDetails === void 0 ? void 0 : linkDetails.productSubCategory) === null || _h === void 0 ? void 0 : _h.title) !== null && _j !== void 0 ? _j : ""
                })
              })
            }), (0, jsx_runtime_1.jsx)(frontend_layout_2.Row, {
              children: (0, jsx_runtime_1.jsx)(frontend_layout_2.Column, {
                lg: 12,
                children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                  size: "sm",
                  color: white,
                  children: (_m = (_l = (_k = linkDetails === null || linkDetails === void 0 ? void 0 : linkDetails.productSubCategory) === null || _k === void 0 ? void 0 : _k.megaMenuBlurb) === null || _l === void 0 ? void 0 : _l.megaMenuBlurb) !== null && _m !== void 0 ? _m : ""
                })
              })
            })]
          })
        })]
      }), (0, jsx_runtime_1.jsx)(frontend_layout_2.Row, {
        children: (0, jsx_runtime_1.jsx)(frontend_layout_2.Column, {
          lg: 12,
          children: (0, jsx_runtime_1.jsx)(Divider, {
            css: (0, react_2.css)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\tmargin-bottom: 30px;\n\t\t\t\t\t\t\t\tmargin-top: 20px;\n\t\t\t\t\t\t\t"])))
          })
        })
      }), characteristics.length > 0 && (0, jsx_runtime_1.jsxs)(frontend_layout_2.Row, {
        children: [(0, jsx_runtime_1.jsx)(frontend_layout_2.Column, {
          lg: 4,
          children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            size: "xs",
            color: lightGray,
            variant: "div",
            css: (0, react_2.css)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\tpadding-bottom: 10px;\n\t\t\t\t\t\t\t\t"]))),
            children: "Characteristics"
          })
        }), (0, jsx_runtime_1.jsx)(frontend_layout_2.Column, {
          lg: 8,
          children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            size: "xs",
            color: white,
            variant: "div",
            css: (0, react_2.css)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\tpadding-bottom: 10px;\n\t\t\t\t\t\t\t\t"]))),
            children: characteristics.join(", ")
          })
        })]
      }), ((_o = linkDetails === null || linkDetails === void 0 ? void 0 : linkDetails.productSubCategory) === null || _o === void 0 ? void 0 : _o.applications) && ((_p = linkDetails === null || linkDetails === void 0 ? void 0 : linkDetails.productSubCategory) === null || _p === void 0 ? void 0 : _p.applications.length) > 0 && (0, jsx_runtime_1.jsxs)(frontend_layout_2.Row, {
        children: [(0, jsx_runtime_1.jsx)(frontend_layout_2.Column, {
          lg: 4,
          children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            size: "xs",
            color: lightGray,
            variant: "div",
            css: (0, react_2.css)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\tpadding-bottom: 10px;\n\t\t\t\t\t\t\t\t\t"]))),
            children: "Popular Applications"
          })
        }), (0, jsx_runtime_1.jsx)(frontend_layout_2.Column, {
          lg: 8,
          children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            size: "xs",
            color: white,
            variant: "div",
            css: (0, react_2.css)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\tpadding-bottom: 10px;\n\t\t\t\t\t\t\t\t\t"]))),
            children: (_r = (_q = linkDetails === null || linkDetails === void 0 ? void 0 : linkDetails.productSubCategory) === null || _q === void 0 ? void 0 : _q.applications) === null || _r === void 0 ? void 0 : _r.join(", ")
          })
        })]
      }), grades.length > 0 && (0, jsx_runtime_1.jsxs)(frontend_layout_2.Row, {
        children: [(0, jsx_runtime_1.jsx)(frontend_layout_2.Column, {
          lg: 4,
          children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            size: "xs",
            color: lightGray,
            variant: "div",
            css: (0, react_2.css)(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\tpadding-bottom: 10px;\n\t\t\t\t\t\t\t\t"]))),
            children: "Popular Grades"
          })
        }), (0, jsx_runtime_1.jsx)(frontend_layout_2.Column, {
          lg: 8,
          children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            size: "xs",
            color: white,
            variant: "div",
            css: (0, react_2.css)(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\tpadding-bottom: 10px;\n\t\t\t\t\t\t\t\t"]))),
            children: grades.join(", ")
          })
        })]
      }), (_t = (_s = linkDetails === null || linkDetails === void 0 ? void 0 : linkDetails.productSubCategory) === null || _s === void 0 ? void 0 : _s.dimensionRanges) === null || _t === void 0 ? void 0 : _t.map(function (dimensionRange) {
        return (0, jsx_runtime_1.jsxs)(frontend_layout_2.Row, {
          children: [(0, jsx_runtime_1.jsx)(frontend_layout_2.Column, {
            lg: 4,
            children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
              size: "xs",
              color: lightGray,
              variant: "div",
              css: (0, react_2.css)(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\tpadding-bottom: 10px;\n\t\t\t\t\t\t\t\t\t"]))),
              children: dimensionRange === null || dimensionRange === void 0 ? void 0 : dimensionRange.dimension
            })
          }), (0, jsx_runtime_1.jsx)(frontend_layout_2.Column, {
            lg: 8,
            children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
              size: "xs",
              color: white,
              variant: "div",
              css: (0, react_2.css)(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\tpadding-bottom: 10px;\n\t\t\t\t\t\t\t\t\t"]))),
              children: dimensionRange === null || dimensionRange === void 0 ? void 0 : dimensionRange.range
            })
          })]
        });
      })]
    });
  };

  return (0, jsx_runtime_1.jsx)(react_1.default.Fragment, {
    children: (0, jsx_runtime_1.jsx)(MenuContainer, {
      children: isExpanded && (0, jsx_runtime_1.jsx)(react_1.default.Fragment, {
        children: (0, jsx_runtime_1.jsx)(frontend_layout_1.Container, {
          vPadding: "0",
          css: (0, react_2.css)(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\tbackground: ", ";\n\t\t\t\t\t\t\t"])), background),
          children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
            children: [(0, jsx_runtime_1.jsxs)(frontend_layout_1.FlexItem, {
              css: (0, react_2.css)(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\twidth: 65%;\n\t\t\t\t\t\t\t\t\t\tpadding-top: 36px;\n\t\t\t\t\t\t\t\t\t\tposition: relative;\n\t\t\t\t\t\t\t\t\t"]))),
              children: [(0, jsx_runtime_1.jsx)(frontend_layout_2.Grid, {
                gutter: 0,
                children: (0, jsx_runtime_1.jsx)(frontend_layout_2.Row, {
                  children: (_a = product === null || product === void 0 ? void 0 : product.megaMenuProductGroups) === null || _a === void 0 ? void 0 : _a.map(function (productGroup, index) {
                    var _a;

                    return (0, jsx_runtime_1.jsx)(frontend_layout_2.Column, {
                      xs: 4,
                      children: (0, jsx_runtime_1.jsxs)(Box, {
                        children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                          size: "md",
                          color: white,
                          children: productGroup.label
                        }), (0, jsx_runtime_1.jsx)(Divider, {}), (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
                          direction: "column",
                          justifyContent: "center",
                          css: (0, react_2.css)(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tpadding-bottom: 30px;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"]))),
                          children: (_a = productGroup === null || productGroup === void 0 ? void 0 : productGroup.megaMenuLinks) === null || _a === void 0 ? void 0 : _a.map(function (link, index) {
                            return (0, jsx_runtime_1.jsx)(frontend_navigation_2.Link, {
                              gatsby: (0, util_1.isGatsbyLink)(true, storeDirectory),
                              to: (0, util_1.isGatsbyLink)(true, storeDirectory) ? link.url.replace("/store", "") : link.url,
                              dataTestId: "product-menu-mega-menu-item-link",
                              children: (0, jsx_runtime_1.jsx)(exports.StructuredShapeMenu, {
                                linkDetails: link,
                                onMouseEnterLeave: setHighlightedShape
                              })
                            }, "link-".concat(index));
                          })
                        })]
                      })
                    }, "menu-column-".concat(index));
                  })
                })
              }), (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
                css: {
                  height: "197px",
                  width: "236px",
                  padding: "32px",
                  position: "absolute",
                  bottom: 0,
                  right: 0,
                  marginRight: "15px"
                },
                direction: "column",
                justifyContent: "center",
                alignItems: "center",
                children: (0, jsx_runtime_1.jsx)(frontend_navigation_1.ButtonLink, {
                  label: [content.metalHelpText1, content.metalHelpText2],
                  to: "".concat(buttonLinkPath === null || buttonLinkPath === void 0 ? void 0 : buttonLinkPath.url),
                  type: "tertiary"
                })
              })]
            }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
              direction: "column",
              justifyContent: "space-between",
              css: (0, react_2.css)(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\twidth: 35%;\n\t\t\t\t\t\t\t\t\t\tpadding: 30px 20px;\n\t\t\t\t\t\t\t\t\t"]))),
              children: [!highlightedShape && getProductSummary(), highlightedShape && getShapeDetails(highlightedShape)]
            })]
          })
        })
      })
    })
  });
};

exports.StructuredProductMenu = StructuredProductMenu;

var StructuredShapeMenu = function StructuredShapeMenu(_ref4) {
  var linkDetails = _ref4.linkDetails,
      onMouseEnterLeave = _ref4.onMouseEnterLeave;

  var _ref5 = (0, frontend_theme_1.useTheme)(),
      theme = _ref5.theme;

  var _theme$colors$primary2 = theme.colors.primary,
      lightGray = _theme$colors$primary2.lightGray,
      primaryBrand = _theme$colors$primary2.primaryBrand;

  var onHovered = function onHovered(hovered) {
    hovered && onMouseEnterLeave(linkDetails);
    !hovered && onMouseEnterLeave();
  };

  return (0, jsx_runtime_1.jsx)("div", {
    onMouseEnter: function onMouseEnter() {
      return onHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return onHovered(false);
    },
    css: (0, react_2.css)(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n\t\t\t\tflex-align: center;\n\t\t\t\tmin-height: 30px;\n\t\t\t"]))),
    "data-testid": "mega-menu-product-item-link",
    children: (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
      grow: 1,
      children: (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
        children: (0, jsx_runtime_1.jsxs)("div", {
          css: (0, react_2.css)(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\tflex-grow: 1;\n\t\t\t\t\t\t\t&:hover > div {\n\t\t\t\t\t\t\t\tcursor: pointer;\n\t\t\t\t\t\t\t\tcolor: ", ";\n\t\t\t\t\t\t\t\t& span:first-of-type {\n\t\t\t\t\t\t\t\t\tcolor: ", ";\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t"])), primaryBrand, primaryBrand),
          children: [(0, jsx_runtime_1.jsx)("div", {
            children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
              icon: linkDetails.icon,
              size: "sm",
              color: lightGray,
              css: (0, react_2.css)(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\t\tcursor: pointer;\n\t\t\t\t\t\t\t\t\t\tcolor: ", ";\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t"])), primaryBrand),
              dataTestId: "mega-menu-product-link-icon"
            })
          }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            variant: "div",
            size: "sm",
            type: "tertiary",
            css: (0, react_2.css)(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\tpadding-left: 10px;\n\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\tcursor: pointer;\n\t\t\t\t\t\t\t\t\tcolor: ", ";\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t"])), primaryBrand),
            dataTestId: "mega-menu-product-link-label",
            children: linkDetails.label
          })]
        })
      })
    })
  });
};

exports.StructuredShapeMenu = StructuredShapeMenu;

var ShapeMenu = function ShapeMenu(_ref6) {
  var shape = _ref6.shape,
      onMouseEnterLeave = _ref6.onMouseEnterLeave;

  var _ref7 = (0, frontend_theme_1.useTheme)(),
      theme = _ref7.theme;

  var _theme$colors$primary3 = theme.colors.primary,
      lightGray = _theme$colors$primary3.lightGray,
      primaryBrand = _theme$colors$primary3.primaryBrand;

  var onHovered = function onHovered(hovered) {
    hovered && onMouseEnterLeave(shape);
    !hovered && onMouseEnterLeave();
  };

  return (0, jsx_runtime_1.jsx)("div", {
    onMouseEnter: function onMouseEnter() {
      return onHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return onHovered(false);
    },
    css: (0, react_2.css)(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n\t\t\t\tflex-align: center;\n\t\t\t\theight: 30px;\n\t\t\t"]))),
    children: (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
      grow: 1,
      children: (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
        children: (0, jsx_runtime_1.jsxs)("div", {
          css: (0, react_2.css)(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\tflex-grow: 1;\n\t\t\t\t\t\t\t&:hover > div {\n\t\t\t\t\t\t\t\tcursor: pointer;\n\t\t\t\t\t\t\t\tcolor: ", ";\n\t\t\t\t\t\t\t\t& span:first-of-type {\n\t\t\t\t\t\t\t\t\tcolor: ", ";\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t"])), primaryBrand, primaryBrand),
          children: [(0, jsx_runtime_1.jsx)("div", {
            children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
              icon: shape.icon,
              size: "sm",
              color: lightGray,
              css: (0, react_2.css)(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\t\tcursor: pointer;\n\t\t\t\t\t\t\t\t\t\tcolor: ", ";\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t"])), primaryBrand)
            })
          }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            variant: "div",
            size: "sm",
            type: "tertiary",
            css: (0, react_2.css)(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\tpadding-left: 10px;\n\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\tcursor: pointer;\n\t\t\t\t\t\t\t\t\tcolor: ", ";\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t"])), primaryBrand),
            children: shape === null || shape === void 0 ? void 0 : shape.display
          })]
        })
      })
    })
  });
};

exports.ShapeMenu = ShapeMenu;